import { render } from "./PrintEventsComp.vue?vue&type=template&id=b4b904e2&scoped=true"
import script from "./PrintEventsComp.vue?vue&type=script&lang=js"
export * from "./PrintEventsComp.vue?vue&type=script&lang=js"

import "./PrintEventsComp.vue?vue&type=style&index=0&id=b4b904e2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4b904e2"]])

export default __exports__